



















































	import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import { store, CDR, StoreState } from '../store';
    import VueElementLoading from 'vue-element-loading';
    import {RotateSquare2} from 'vue-loading-spinner';
    import { mapState } from 'vuex';
    import util from '../lib/util';

	@Component({
        components: {
            RotateSquare2,VueElementLoading
		},
		computed: {
			...mapState({
                'medea_data': (state: StoreState) => state.reports.record_data,
			})
		}
    })
	export default class RecordsPlay extends Vue {
      

        data() {
            return {
                is_loading: false,
                selectedDevice: null,
                show_modal :true,
                title: 'dummy ',
                src_url:'',
                display : false,
                playing: false,
                progress: 0,
                duration: 0,
                current_time: '',
            }
        }


        created() {
            this.$data.title = (this as any).medea_data.timestamp;//"0_3587859745@10.10.24.52";
            this.$data.src_url =(this as any).medea_data.media_url;// "https://s3-us-west-2.amazonaws.com/spokerecordings/173d9d1269761052da83512b3e47fbe7/call_recording_0_7659796@10.10.24.52.mp3";//src_url;//
            this.$data.show_modal = true;
            this.$data.display = false;
             
        }

        playRecording() {
            this.$data.playing = true;
            (this.$refs.audio as HTMLAudioElement).play();
        }

        pauseRecording() {
            this.$data.playing = false;
            (this.$refs.audio as HTMLAudioElement).pause();
        }
        canplayaudio()
        {
            if (this.$refs.audio) {
                this.playRecording() ;
               this.$data.display=true;;
            }
        }

        updateDuration() {
            if (this.$refs.audio) {
                this.$data.duration = (this.$refs.audio as HTMLAudioElement).duration;
            }
        }
        
        updateCurrentCallTime(event) {
            this.$data.current_time = (this.$refs.audio as HTMLAudioElement).currentTime;
            this.$data.progress = Math.floor((this.$data.current_time/this.$data.duration)*100);
        }
           get formattedDuration() {
            let secs = Math.floor(this.$data.duration);
            const mins = Math.floor(secs / 60);
            secs %= 60;
            const sec_string = (secs.toString() as any).padStart(2, '0');
            return `${mins}:${sec_string}`;
        }

        get formattedCurrentTime() {
            let secs = Math.floor(this.$data.current_time);
            const mins = Math.floor(secs / 60);
            secs %= 60;
            const sec_string = (secs.toString() as any).padStart(2, '0');
            return `${mins}:${sec_string}`;
        }
        
        grabbedScrubber(event) {
            this.$data.draggable = false;
            this.$data.initalDragX = event.clientX;
            this.pauseRecording();
            document.addEventListener('mousemove', this.mouseMoveListener);
            document.addEventListener('mouseup', this.mouseUpListener);
        }

        mouseMoveListener(e: any) {
            const scrubberWidth = (this.$refs.scrubber as any).clientWidth;
            const scrubberRects = (this.$refs.scrubber as any).getClientRects()[0];
            const relPosition = Math.floor(e.clientX - scrubberRects.left);
            if (relPosition <= 0) {
                this.$data.progress = 0;
            } else if(relPosition >= scrubberWidth) {
                this.$data.progress = 100;
            } else {
                this.$data.progress = Math.floor((relPosition/scrubberWidth)*100);
            }
            this.$data.current_time = (this.$data.duration*(this.$data.progress/100));
        }

        mouseUpListener() {
            (this.$refs.audio as HTMLAudioElement).currentTime = (this.$data.duration*(this.$data.progress/100));
            document.removeEventListener('mouseup', this.mouseUpListener);
            document.removeEventListener('mousemove', this.mouseMoveListener); 
            this.playRecording();  
        }


	}
